export interface RewardTier {
  name: string;
  minConversions: number;
  color: string;
  bgColor: string;
  borderColor: string;
  iconBg: string;
}

export const REWARD_TIERS: RewardTier[] = [
  {
    name: "Unranked",
    minConversions: 0,
    color: "text-gray-400",
    bgColor: "bg-gray-50",
    borderColor: "border-gray-200",
    iconBg: "bg-gray-100",
  },
  {
    name: "Bronze",
    minConversions: 1,
    color: "text-amber-700",
    bgColor: "bg-amber-50",
    borderColor: "border-amber-300",
    iconBg: "bg-amber-100",
  },
  {
    name: "Silver",
    minConversions: 5,
    color: "text-gray-500",
    bgColor: "bg-gray-50",
    borderColor: "border-gray-300",
    iconBg: "bg-gray-200",
  },
  {
    name: "Gold",
    minConversions: 25,
    color: "text-yellow-600",
    bgColor: "bg-yellow-50",
    borderColor: "border-yellow-400",
    iconBg: "bg-yellow-100",
  },
  {
    name: "Platinum",
    minConversions: 100,
    color: "text-blue-600",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-300",
    iconBg: "bg-blue-100",
  },
  {
    name: "Diamond",
    minConversions: 500,
    color: "text-cyan-500",
    bgColor: "bg-cyan-50",
    borderColor: "border-cyan-300",
    iconBg: "bg-cyan-100",
  },
  {
    name: "Elite",
    minConversions: 1000,
    color: "text-purple-600",
    bgColor: "bg-purple-50",
    borderColor: "border-purple-400",
    iconBg: "bg-purple-100",
  },
];

export function getCurrentTier(totalConversions: number): RewardTier {
  for (let i = REWARD_TIERS.length - 1; i >= 0; i--) {
    if (totalConversions >= REWARD_TIERS[i].minConversions) {
      return REWARD_TIERS[i];
    }
  }
  return REWARD_TIERS[0];
}

export function getNextTier(totalConversions: number): RewardTier | null {
  const current = getCurrentTier(totalConversions);
  const currentIndex = REWARD_TIERS.indexOf(current);
  if (currentIndex >= REWARD_TIERS.length - 1) return null;
  return REWARD_TIERS[currentIndex + 1];
}

export function getTierProgress(totalConversions: number): number {
  const current = getCurrentTier(totalConversions);
  const next = getNextTier(totalConversions);
  if (!next) return 100;
  const range = next.minConversions - current.minConversions;
  const progress = totalConversions - current.minConversions;
  return Math.min(100, Math.round((progress / range) * 100));
}
